import { useQuery } from "@tanstack/react-query";
import { MyLoading } from "components/atoms/MyLoading";
import { useState } from "react";
import { Card, Loading } from "react-daisyui";


const fetchClubInfos = async () => {
  const res = await fetch("/api/v1/club_infos");
  return res.json();
};

export default function ClubInfosIndex() {
  const { data: club_infos = [], isLoading } = useQuery({
    queryKey: ["clubinfos"],
    queryFn: fetchClubInfos,
  });

  const [region, setRegion] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 10;

  const filtered = club_infos.filter((club) => {
    const matchesRegion = region ? club.region === region : true;
    const matchesSearch = club.name && club.name.includes(search);
    club.region && club.region.includes(search) ||
      club.manager_name && club.manager_name.includes(search);
    return matchesRegion && matchesSearch;
  });

  const paginated = filtered.slice((page - 1) * pageSize, page * pageSize);
  const totalPages = Math.ceil(filtered.length / pageSize);

  if (isLoading) {
    return <MyLoading />;
  }

  return (
    <div className="p-4">
      <div className="flex flex-wrap gap-2 mb-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">
            클럽
          </h2>
          {/* <div className="form-control">
            <input type="text" placeholder="검색어를 입력하세요." className="input input-bordered w-64" />
          </div> */}
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-4">
        <select
          className="select select-bordered"
          value={region}
          onChange={(e) => setRegion(e.target.value)}
        >
          <option value="">전체 지역</option>
          <option value="서울">서울</option>
          <option value="부산">부산</option>
          <option value="대구">대구</option>
          <option value="광주">광주</option>
          {/* 추가 지역 필요시 여기에 */}
        </select>
        <input
          type="text"
          className="input input-bordered"
          placeholder="모임 이름, 지역, 모임장 검색"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {paginated.length === 0 ? (
          <div className="text-center text-gray-500 col-span-full min-h-[200px] pt-20">
            검색 결과가 없습니다.
          </div>
        ) : (
          paginated.map((club) => (
            <Card key={club.id} className="bg-base-100 shadow-md">
              <Card.Body>
                <div className="flex justify-between">
                  <div>
                    <h2 className="card-title">
                      <a href={`/club_infos/${club.id}`}>{club.name}</a>
                    </h2>
                    <p><strong>모임장:</strong> {club.manager_name}</p>
                    <p><strong>연락처:</strong> {club.tel}</p>
                    <p><strong>장소:</strong> {club.homepage}</p>
                  </div>
                  <div className="floatRight">
                    <img
                      src={club.book_image_url}
                      alt={club.book_title}
                      className="w-24 h-32 object-cover mt-2"
                    />
                  </div>
                </div>
              </Card.Body>
              {/* <Card.Actions className="justify-end px-4 pb-4">
                <button className="btn btn-sm btn-outline">후기 보기</button>
                <button className="btn btn-sm btn-primary">후기 작성</button>
              </Card.Actions> */}
            </Card>
          ))
        )}
      </div>

      <div className="join self-center mt-8 flex justify-center">
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`join-item btn btn-sm ${page === i + 1 ? 'btn-primary' : ''}`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
}
